export const VAGO_BUSINESS_INTERNAL_NAME = 'tenement_apartments_row_housing';
export const VAGO_POLICY_INTERNAL_NAMES = ['property'];
